import React from 'react'
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap'
import { useReports } from 'hooks/useUploadFile/useReports';
import EmailInput from 'components/EmailInput/EmailInput';
import { LoadingSpinner } from 'views/MassiveResults/LoadingComponent';
import { ReportsSuccess } from './ReportsSuccessComponent';
import { ReportError } from './ReportsErrorComponent';

const ReportsView = () => {
    const {
        loading,
        error,
        handleSetReportType,
        handleEmailsChange,
        handleSendReports,
        emails,
        selectedReport,
        handleCloseReportSuccess,
        handleCloseReportError,
        reportsSuccess
    } = useReports();

    return (
        <Container className='mt-3'>
            <Row>
                {loading ? (<LoadingSpinner />) : null}
                <Col sm={12} lg={12} md={12} className='mt-3'>
                    <Card>
                        <Card.Header className='text-center'>
                            <h5 className='title-module' >Módulo para descarga de reportes</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row className='mt-4'>
                                <Col sm={6} lg={6} md={6}>
                                    <Form.Select 
                                        aria-label="Default select example"
                                        name="operativeType"
                                        value={selectedReport || ""}
                                        onChange={(e => handleSetReportType(e.target.value))}
                                    >
                                        <option value="">Seleccione un Reporte</option>
                                        <option value="cranial-massage">Masaje Cranial</option>
                                        <option value="general-massage">Masaje General</option>
                                        <option value="kinesiology">Kinesiologia</option>
                                        <option value="prostate-antigen">Antigeno Prostatico</option>
                                        <option value="cardiovascular">Cardiovascular</option>
                                        <option value="cv-prostate-antigen">CV Antingeno Prostatico</option>
                                        <option value="cardiovascular-lite">Cardiovascular (Lite)</option>
                                        <option value="consolidated">Consolidado</option>
                                        <option value="consolidated-full">Consolidado (detallado)</option>
                                        <option value="audiometry">Audiometria</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col sm={6} lg={6} md={6}>
                                    <EmailInput 
                                        handleEmailsChange={handleEmailsChange}
                                        emails={emails}
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col sm={6} lg={6} md={6}>
                                    <Button
                                        variant='success'
                                        className='btn btn-success btn-saves'
                                        disabled={loading || !selectedReport || emails.length === 0}
                                        onClick={handleSendReports}
                                    >
                                        Enviar reportes
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {reportsSuccess ? (<ReportsSuccess show={reportsSuccess} handleClose={handleCloseReportSuccess} />) : null}
            {error ? (<ReportError show={error} handleClose={handleCloseReportError} />) : null}    
        </Container>
    );
}
 
export default ReportsView;